module.exports = __webpack_public_path__ + "static/media/rsAnimeOP3.64945bea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press/rsAnimeOP3.jpg
// module id = 568
// module chunks = 0